/*
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */

import React, {
  useState,
  useEffect,
  useRef,
  lazy,
  Suspense,
  Fragment,
} from "react";
import Navbar from "react-bootstrap/Navbar";
import Image from "react-bootstrap/Image";
import Container from "react-bootstrap/Container";
import { Link, useLocation } from "react-router-dom";
import StyledHeader from "./styles";
import "./index.css";
const UserWayAccessibilityMenu = lazy(() =>
  import("../UserWayAccessibilityMenu")
);
const RigVedPopup = lazy(() => import("../RigVedPopup"));
export default function Header() {
  const [navbarVisible, setNavbarVisible] = useState(true);
  const [navbarSticky, setNavbarSticky] = useState(false);
  const location = useLocation();
  const isTesting = location.pathname === "/staging/test";
  const isHome = location.pathname === "/";
  const prevScrollY = useRef(0); // Initialize prevScrollY

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;

      // Sticky behavior for both desktop and mobile
      if (scrollY >= 10) {
        setNavbarSticky(true);
      } else {
        setNavbarSticky(false);
      }

      // Show navbar when scrolling up or when at the top of the page
      if (window.innerWidth <= 550) {
        if (scrollY < prevScrollY.current || scrollY === 0) {
          setNavbarVisible(true);
        } else {
          setNavbarVisible(false);
        }
        prevScrollY.current = scrollY;
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <StyledHeader>
        <Navbar
          expand="lg"
          className={`${navbarSticky ? "navbar active" : "navbar"} ${!navbarVisible ? "nav-slide" : ""}`}
        >
          <Container className="navbar-container">
            <div className="center-content">
              <Link
                as={isHome ? "a" : Link}
                target={isHome ? "_blank" : ""}
                rel="noreferrer"
                href={
                  `https://www.swmc.com/`
                }
                to={
                  `https://www.swmc.com/`
                }
              >
                <Image
                  src={`https://resources.swmc.com/swmc-images/Homepage/New/SunWest41YearsofTrust-White.svg`}
                  alt={`Sun West Mortgage Logo`}
                  title={`Sun West Mortgage Logo`}
                  className="sunwest-logo"
                />
              </Link>
            </div>
            <div className="center-content">
              <div className="position-relative">
                <a
                  aria-label="Click here to visit AngelAi.com."
                  href={"https://angelai.com"}
                  target="_blank"
                  rel="noreferrer"
                  className="angelai-link"
                >
                  <Image
                    src={`https://resources.swmc.com/angel-ai/latest-angelai-logo.webp`}
                    alt="AngelAi"
                    title="AngelAi logo"
                    className="angelai-logo "
                  />
                </a>
                <div className="rigved-box">Nothing is Beyond Reach</div>
                <div className="pop-up">
                  <Suspense fallback={<Fragment />}>
                    <RigVedPopup />
                  </Suspense>
                </div>
              </div>
              <div className="desktop-show-Accessibility">
                <Suspense fallback={<div />}>
                  <UserWayAccessibilityMenu color="white" width={30} height={30} />
                </Suspense>
              </div>
            </div>
          </Container>
          <div className="mobile-show-Accessibility">
            <Suspense fallback={<div />}>
              <UserWayAccessibilityMenu color="white" width={30} height={30} />
            </Suspense>
          </div>
        </Navbar>
      </StyledHeader >
    </>
  );
}
